import { equals2 } from "fxjs/es";
import { CommonNS } from "../../../../Common/CommonNS.js";
import { VONS } from "../../VO/VONS.js";
import { DATA_KEY_IS_LOCKED } from "../private/const.js";
export class Locking {
  constructor() {
    this._observer_set = new Set();
  }
  subscribe(observer) {
    if (this._observer_set.has(observer)) {
      throw new Error(`이미 등록된 observer 입니다.`);
    }
    this._observer_set.add(observer);
    return () => {
      this._observer_set.delete(observer);
    };
  }
  getIsLocked(el) {
    return equals2("true")(el.dataset[DATA_KEY_IS_LOCKED]);
  }
  lockEl(el) {
    if (this.getIsLocked(el)) {
      return;
    }
    el.dataset[DATA_KEY_IS_LOCKED] = "true";
    this._notify({
      type: "LOCK",
      el,
    });
    el.dispatchEvent(
      new CustomEvent("@mp/sticker-editor/lock", {
        bubbles: true,
        cancelable: true,
        composed: false,
        detail: {
          el,
        },
      })
    );
  }
  unlockEl(el) {
    if (!this.getIsLocked(el)) {
      return;
    }
    el.dataset[DATA_KEY_IS_LOCKED] = "false";
    this._notify({
      type: "UNLOCK",
      el,
    });
    el.dispatchEvent(
      new CustomEvent("@mp/sticker-editor/unlock", {
        bubbles: true,
        cancelable: true,
        composed: false,
        detail: {
          el,
        },
      })
    );
  }
  _notify(locking_vo) {
    for (const observer of this._observer_set) {
      CommonNS.UtilNS.tryNoop(() => observer(locking_vo));
    }
  }
}
